import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const courierPropRecord = async (params: object) => {
  return await GET({ url: Api.courierPropRecord, params, showError: false })
}
